import axios from 'axios';

let common = {
    p_h0: window.p_h0,
    axios: axios.create({
        baseURL: window.p_h0 + '/',
        withCredentials: true
    }),
    formatDate(str) {
        let oDate = new Date(str);
        if ('Invalid Date' == oDate) return oDate;
        let oYear = oDate.getFullYear(),
            oMonth = oDate.getMonth() < 9 ? "0" + (oDate.getMonth() + 1) : (oDate.getMonth() + 1),
            oDay = oDate.getDate() < 10 ? "0" + oDate.getDate() : oDate.getDate(),
            oHour = oDate.getHours() < 10 ? "0" + oDate.getHours() : oDate.getHours(),
            oMinute = oDate.getMinutes() < 10 ? "0" + oDate.getMinutes() : oDate.getMinutes(),
            oSecond = oDate.getSeconds() < 10 ? "0" + oDate.getSeconds() : oDate.getSeconds(),
            oTime = oYear + '-' + oMonth + '-' + oDay + " " + oHour + ":" + oMinute + ":" + oSecond; //最后拼接时间
        return oTime;
    },
    formatSize(size) {
        if (typeof size !== "number") size = NaN;
        if (isNaN(size)) return '--';
        let count = 0;
        while (size >= 1024) {
            size /= 1024;
            count++;
        }
        size = size.toFixed(2);
        size += [' B', ' KB', ' MB', ' GB'][count];
        return size;
    },
    urlSpCharEncode(s) {
        if (!s) return s;
        let res = '';
        for (let len = s.length, i = 0; i < len; i++) {
            let ch = s[i];
            switch (ch) {
                case '%':
                    res += '%25';
                    break;
                case '?':
                    res += '%3f';
                    break;
                case '#':
                    res += '%23';
                    break;
                case ' ':
                    res += '%20';
                    break;
                default:
                    res += ch;
            }
        }
        return res;
    },
    completeUrl(path) {
        return (
            this.p_h0 +
            this.urlSpCharEncode(path)
        );
    }
};

export default common;